import { UiSchema } from '@rjsf/utils'
import { ChannelSchema } from '@feedyou-ai/feedbot-schema'

export const uiSchema: UiSchema = {
  items: {
    id: {
      'ui:widget': 'WebchatSharedWidget',
      'ui:readonly': true,
      generateId: true
    },
    channelType: {
      type: {
        'ui:widget': 'hidden'
      }
    },
    service: {
      'ui:widget': 'hidden'
    },
    type: {
      'ui:widget': 'hidden'
    },
    pbx: {
      dialer: {
        'ui:classNames': 'form-checkbox-move-right-by-column'
      }
    },
    instructions: { 'ui:widget': 'textarea' },
    realtimeService: {
      'ui:widget': 'BotCloudServiceSelectWidget',
      kind: 'llm-realtime',
      action: 'Realtime response'
    },
    audio: {
      transcription: {
        prompt: { 'ui:widget': 'textarea' }
      },
      turnDetection: {
        type: {
          'ui:widget': 'hidden'
        }
      }
    },
    textToSpeech: { type: { 'ui:widget': 'hidden' } },
    campaigns: {
      items: {
        'ui:label': false,
        id: { 'ui:widget': 'CampaignControlWidget' },
        inputs: {
          items: { 'ui:label': false, storage: { 'ui:widget': 'StepStorageSummaryWidget' } }
        }
      }
    },
    webhookSecret: {
      'ui:widget': 'hidden'
    },
    botName: {
      'ui:widget': 'hidden'
    },
    keepHistory: {
      'ui:widget': 'hidden'
    },
    customCss: { 'ui:widget': 'EditorCssWidget' },
    customScript: { 'ui:widget': 'EditorJavascriptWidget' },
    template: {
      type: {
        'ui:widget': 'hidden'
      },
      popupMessage: {
        type: {
          'ui:widget': 'hidden'
        }
      }
    },
    signature: {
      mode: {
        'ui:widget': 'hidden'
      },
      partnerLogoStyle: { 'ui:widget': 'textarea' }
    },
    urlFilter: {
      items: { 'ui:label': false }
    },
    userData: {
      items: { 'ui:label': false }
    },
    handoff: {
      'ui:widget': 'hidden',
      type: {
        'ui:widget': 'hidden'
      }
    },
    telephonyControl: {
      'ui:readonly': true,
      'ui:widget': 'TelephonyControlWidget'
    },
    getStartedDialogId: {
      'ui:widget': 'DialogCreatableSelectWidget'
    },
    introDialogId: { 'ui:widget': 'DialogCreatableSelectWidget' },
    genAi: {
      ratingRoles: {
        'ui:widget': 'checkboxes',
        'ui:options': { inline: true },
        'ui:classNames': 'single-line-inline-checkboxes'
      },
      explanationRoles: {
        'ui:widget': 'checkboxes',
        'ui:options': { inline: true },
        'ui:classNames': 'single-line-inline-checkboxes'
      },
      customExplanations: {
        items: {
          roles: {
            'ui:widget': 'checkboxes',
            'ui:options': { inline: true },
            'ui:classNames': 'single-line-inline-checkboxes'
          }
        }
      }
    }
  }
}

export function adjustUiSchemaForFormData(formData: ChannelSchema[]): UiSchema {
  return adjustUiSchemaForFormDataByDialer(formData, uiSchema)
}

function adjustUiSchemaForFormDataByDialer(
  formData: ChannelSchema[],
  uiSchema: UiSchema
): UiSchema {
  const telephonyChannelIndex = formData?.findIndex(channel => channel.type === 'telephony')
  if (telephonyChannelIndex === undefined || telephonyChannelIndex < 0) {
    return uiSchema
  }

  const isDialerEnabled = formData[telephonyChannelIndex]?.pbx?.dialer
  if (isDialerEnabled) {
    return {
      ...uiSchema,
      items: {
        ...uiSchema.items,
        campaigns: {
          items: {
            'ui:label': false,
            id: { 'ui:widget': 'CampaignControlWidget' },
            inputs: {
              items: {
                'ui:label': false,
                storage: { 'ui:widget': 'StepStorageSummaryWidget' },
                type: { 'ui:widget': 'hidden' }
              }
            }
          }
        }
      }
    }
  }

  uiSchema.items.campaigns = { 'ui:widget': 'hidden' }
  return uiSchema
}
